import { Component, inject } from '@angular/core';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { ButtonComponent } from '@ui';

@Component({
  standalone: true,
  selector: 'sbnb-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  imports: [MatDialogModule, ButtonComponent],
})
export class UnsavedChangesDialogComponent {
  readonly dialogRef = inject(MatDialogRef<UnsavedChangesDialogComponent>);

  keepEditing() {
    this.dialogRef.close(false);
  }

  discardChanges() {
    this.dialogRef.close(true);
  }
}
